module.exports = __webpack_public_path__ + "media/images/hero-661b0737232837dbe52a9fd43cf85d10.jpg";